import { z } from 'zod';
import { createProjectRequest } from './project.js';
/**
 * Feld-Zuweisungen + Feld-Historie (Kollaborations-Editieren).
 * Spec: docs/spec/spec-feld-zuweisungen-kollaboration.md (Entscheidung 2026-07-03)
 *
 * Mitwirkende (`lead`/`editor`-Assignments) dürfen fremde Projekte NUR in den
 * ihnen zugewiesenen Feldern editieren. Jede Feldänderung (egal von wem)
 * landet append-only in der FieldHistory — „wer hat wann was geändert".
 */
/**
 * Zuweisbare Projekt-Felder = alle Inhaltsfelder des Projektformulars.
 * Abgeleitet aus dem createProjectRequest-Schema (Single Source of Truth) —
 * neue Formularfelder werden damit automatisch zuweisbar. `customerId` ist
 * Projekt-Identität, keine fachliche „Frage".
 */
const NON_ASSIGNABLE_KEYS = new Set(['customerId']);
export const ASSIGNABLE_PROJECT_FIELD_KEYS = Object.freeze(Object.keys(createProjectRequest.shape).filter((k) => !NON_ASSIGNABLE_KEYS.has(k)));
export const assignableFieldKey = z
    .string()
    .refine((k) => ASSIGNABLE_PROJECT_FIELD_KEYS.includes(k), {
    message: 'Unbekanntes oder nicht zuweisbares Projektfeld.',
});
export const fieldAssignmentDto = z.object({
    id: z.number().int().positive(),
    projectId: z.number().int().positive(),
    userId: z.number().int().positive(),
    fieldKey: z.string(),
    assignedById: z.number().int().positive(),
    assignedAt: z.string().datetime(),
    user: z
        .object({
        id: z.number().int().positive(),
        fullName: z.string(),
        email: z.string().email(),
    })
        .optional(),
});
/**
 * Replace-Set-Semantik pro Mitwirkendem: die übergebene Liste ersetzt die
 * aktiven Zuweisungen dieses Users komplett (entfernte Keys → removedAt).
 * Leere Liste = alle Zuweisungen des Users entziehen.
 */
export const setFieldAssignmentsRequest = z
    .object({
    userId: z.number().int().positive(),
    fieldKeys: z.array(assignableFieldKey).max(ASSIGNABLE_PROJECT_FIELD_KEYS.length),
})
    .strict();
export const fieldHistoryEntry = z.object({
    id: z.number().int().positive(),
    fieldKey: z.string(),
    oldValue: z.unknown().nullable(),
    newValue: z.unknown().nullable(),
    changedAt: z.string().datetime(),
    changedBy: z.object({
        id: z.number().int().positive(),
        fullName: z.string(),
    }),
});
export const fieldHistoryQuery = z
    .object({
    fieldKey: assignableFieldKey.optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
})
    .strict();
